/* eslint-disable @typescript-eslint/no-explicit-any */
import { type ColorResult } from "react-color";

export const handleColorsChange = (color: ColorResult, onChange: (...event: any) => void) => {
	const rgbaString = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`;
	onChange(rgbaString);
};
